'use client'

import {
    SignInButton, SignUpDescription,
    SignUpTitle, SignupTitleDescWrapper,
    SignUpWrapper
} from "@/components/Auth/SignUp/SignUp.styled";
import {useState} from "react";
import {Text} from "@/components/Auth/SignUp/SignUp.styled";
import SignUpFormAction from "@/components/Auth/SignUp/SignUpFormAction";
import VerifyEmailModal from "@/components/Auth/VerifyEmailModal/VerifyEmailModal";
import ConfirmEmailModal from "@/components/Auth/ConfirmEmailModal/ConfirmEmailModal";
import {useTranslations} from "next-intl";
import SignUpFields from "@/components/Auth/SignUp/SignUpFields";

const SignUp = () => {
    const [emailAddress, setEmailAddress] = useState('')
    const t = useTranslations('Auth')

    return (
        <SignUpWrapper>
            <SignupTitleDescWrapper>
                <SignUpTitle>{t('SignUpForm.title')}</SignUpTitle>
                <SignUpDescription>{t('SignUpForm.subtitle')}</SignUpDescription>
            </SignupTitleDescWrapper>
            <SignUpFormAction>
                <SignUpFields
                    emailAddress={emailAddress}
                    setEmailAddress={setEmailAddress}
                />
            </SignUpFormAction>
            <ConfirmEmailModal email={emailAddress}/>
            <VerifyEmailModal maskClosable={true} />
            <Text>{t('SignUpForm.question')} <SignInButton>{t('Buttons.login')}</SignInButton></Text>
        </SignUpWrapper>
    );
};

export default SignUp;
